module.exports = __webpack_public_path__ + "img/projects-aspark.67cf86bc.jpg";